import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana101Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1462_13744)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M583.724 574.075L564.868 536.361L519.902 561.02L541.659 605.986C550.846 601.634 570.96 592.061 577.922 588.58C584.885 585.098 584.691 577.459 583.724 574.075Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M496.689 627.745L541.655 605.987L521.348 565.373L466.229 592.933C470.58 603.086 476.092 616.431 480.734 623.393C485.375 630.356 492.821 628.712 496.689 627.745Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M447.378 552.318L466.235 592.932L521.354 565.373L502.497 526.209L447.378 552.318Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M543.11 488.494L564.868 536.361L519.902 561.019L496.694 511.702L543.11 488.494Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M519.9 440.627L543.108 488.494L496.692 511.702L474.934 463.835L519.9 440.627Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M498.141 394.215L519.899 440.631L474.933 463.839L453.175 417.423L498.141 394.215Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M428.518 513.152L447.374 552.316L502.493 526.207L485.087 487.043L428.518 513.152Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M411.111 473.992L428.517 513.156L485.087 487.046L467.681 447.883L411.111 473.992Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M392.255 436.28L411.112 473.993L467.682 447.884L448.825 408.721L392.255 436.28Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M480.736 355.049L498.142 394.212L453.176 417.42L428.518 369.554C432.869 367.136 444.763 360.56 457.528 353.598C470.292 346.636 478.318 351.664 480.736 355.049Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M392.257 436.28L448.827 408.72L428.518 369.557C415.464 375.359 387.906 387.833 382.104 391.314C376.302 394.795 376.785 403.402 377.752 407.27L392.257 436.28Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13744" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13744" transform="matrix(0.00198961 0 0 0.00263769 -4.07184 -2.39956)"/>
    </pattern>
    <image id="image0_1462_13744" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};